export default "__VITE_ASSET__ClF0Mm0k__"